import React, { useEffect, useState } from "react";
import dataAbout from "../assets/fake-data/data-about";
import dataCollection from "../assets/fake-data/data-collection";
import dataRoadmap from "../assets/fake-data/data-roadmap";
import dataWork from "../assets/fake-data/data-work";
import About2 from "../components/about/About2";
import Banner02 from "../components/banner/Banner02";
import Collection01 from "../components/collection/Collection01";

import Footer2 from "../components/footer/Footer2";
import Work02 from "../components/work/Work02";
import Logo from "../components/logo/Logo";

import RoadMap from "../components/roadmap/RoadMap";
import Faqs2 from "../components/faqs/Faqs2";
import { fatchOffers } from "../services/offers/offersApi";
import { ToastContainer, toast } from "react-toastify";
import ComfortTrade from "../components/about/ComfortTrade";
import About3 from "../components/about/About3";
import DataFaqs from "../assets/fake-data/data-faq";
import Loader from "../components/loader/loader";
import img from "../assets/images/slider/bg-slider.jpg"

function Home02(props) {
  const [offers, setOffers] = useState([]);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(1);
  const [totalRows, setTotalRows] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [imageLoaded, setImageLoaded] = useState(false);

  const getOffers = async () => {
    await fatchOffers(search, limit, page)
      .then((response) => {
        setOffers(response.data.offres);
        setTotalRows(response.data.totalRows);
      })
      .catch((error) => {
        toast.error("api error");
      });
  };

  // Fonction pour précharger l'image
  const preloadImage = (src) => {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = reject;
      image.src = src;
    });
  };

  useEffect(() => {
    const handleLoad = async () => {
      try {
        // Précharger l'image de fond
        await preloadImage(img);
        setImageLoaded(true);
        
        // Vérifier si la page est complètement chargée
        if (document.readyState === "complete") {
          setIsLoading(false);
        } else {
          window.addEventListener("load", () => setIsLoading(false));
        }
      } catch (error) {
        console.error("Erreur lors du chargement de l'image:", error);
        // Même en cas d'erreur, on continue le chargement
        setImageLoaded(true);
        setIsLoading(false);
      }
    };

    handleLoad();

    // Cleanup
    return () => {
      window.removeEventListener("load", () => setIsLoading(false));
    };
  }, []);

  return (
    <> 
    {(isLoading || !imageLoaded) ? (
        <div style={{ 
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "80vh",
        }}>
          <Loader />
        </div>
      ) : (
    
    <div className="home-2">
      <Banner02 img={img} />
      <Logo />

      <Work02 />

      <About2 data={dataAbout} />
      <ComfortTrade />

      {/* <Collection01 data={offers} /> */}

      {/* <RoadMap data={dataRoadmap} /> */}

      <About3 />
      <Faqs2 />

      <Footer2 />
      <ToastContainer draggable />
    </div>
    )}
    </>
  );
}

export default Home02;
